import React from "react";
import CIcon from "@coreui/icons-react";
import {
  cilLaptop,
  cilUser,
  cilMoney,
  cilHouse,
  cilBuilding,
  cilNewspaper,
  cilCamera,
  cilTruck,
  cilPhone,
  cilUserPlus,
} from "@coreui/icons";
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react";
import { useTranslation } from "react-i18next";

const Nav = () => {
  const { t } = useTranslation();

  const _nav = [
    {
      component: CNavItem,
      name: t("menu.dashboard"),
      to: "/dashboard",
    },
    {
      component: CNavTitle,
      name: t("menu.system"),
    },
    {
      component: CNavGroup,
      name: t("menu.access"),
      to: "/dashboard/",
      icon: <CIcon icon={cilLaptop} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: t("menu.users"),
          to: "access/user",
        },
        {
          component: CNavItem,
          name: t("menu.group"),
          to: "access/group",
        },
      ],
    },
    {
      component: CNavTitle,
      name: t("menu.association"),
    },
    {
      component: CNavItem,
      name: t("menu.associates"),
      to: "dashboard/pages/associados",
      icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: t("menu.financial_balance"),
      to: "dashboard/pages/balanco_financeiro",
      icon: <CIcon icon={cilMoney} customClassName="nav-icon" />,
    },
    {
      component: CNavTitle,
      name: t("menu.content"),
    },
    {
      component: CNavGroup,
      name: t("menu.home"),
      to: "/dashboard/",
      icon: <CIcon icon={cilHouse} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: t("menu.home"),
          to: "home/home",
        },
        {
          component: CNavItem,
          name: t("menu.mini_title"),
          to: "home/mini_title",
        },
      ],
    },
    {
      component: CNavGroup,
      name: t("menu.about_us"),
      to: "/base",
      icon: <CIcon icon={cilBuilding} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: t("menu.about_us"),
          to: "about_us/about_us",
        },
        {
          component: CNavItem,
          name: t("menu.accountability"),
          to: "about_us/accountability",
        },
        {
          component: CNavItem,
          name: t("menu.property"),
          to: "about_us/property",
        },
        {
          component: CNavItem,
          name: t("menu.projects_partners"),
          to: "about_us/project",
        },
        {
          component: CNavItem,
          name: t("menu.collaborator"),
          to: "about_us/collaborator",
        },
      ],
    },
    {
      component: CNavGroup,
      name: t("menu.informative"),
      to: "/base",
      icon: <CIcon icon={cilNewspaper} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: t("menu.news"),
          to: "informative/news",
        },
        {
          component: CNavItem,
          name: t("menu.amcatd_journal"),
          to: "informative/journal",
        },
      ],
    },
    {
      component: CNavGroup,
      name: t("menu.events"),
      to: "/base",
      icon: <CIcon icon={cilCamera} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: t("menu.photos_events"),
          to: "event/photos_events",
        },
        {
          component: CNavItem,
          name: t("menu.space_reservations"),
          to: "event/space_reservations",
        },
      ],
    },
    {
      component: CNavGroup,
      name: t("menu.services"),
      to: "/base",
      icon: <CIcon icon={cilTruck} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: t("menu.labor"),
          to: "services/labor",
        },
        {
          component: CNavItem,
          name: t("menu.stores"),
          to: "services/stores",
        },
      ],
    },
    {
      component: CNavItem,
      name: t("menu.contact"),
      to: "/base",
      icon: <CIcon icon={cilPhone} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: t("menu.login"),
      to: "contact/contact",
      icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
    },
  ];

  return _nav;
};

export default Nav;
